module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('vc-nav-drawer', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: (_vm.resize),
      expression: "resize"
    }],
    attrs: {
      "dark": false,
      "fixed": _vm.fixed,
      "temporary": _vm.temporary,
      "application": ""
    },
    model: {
      value: (_vm.open),
      callback: function($$v) {
        _vm.open = $$v
      },
      expression: "open"
    }
  }, [_c('div', {
    class: ['align-center', 'logo-icon']
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('vc-icon', {
    attrs: {
      "color": _vm.primaryColor,
      "size": "x-large"
    }
  }, [_vm._v("mdi-guitar-pick")])], 1)]), _vm._v(" "), _c('vc-list', _vm._l((_vm.menu), function(item, index) {
    return _c('vc-list-item', {
      key: index,
      attrs: {
        "tag": "a",
        "icon": "chevron_right",
        "avatar": item.icon,
        "target": item.target || '_self',
        "to": item.to
      }
    }, [_c('vc-list-item-primary-text', [_vm._v(_vm._s(item.label))])], 1)
  }))], 1), _vm._v(" "), _c('vc-toolbar', {
    class: ['app-bar'],
    attrs: {
      "fixed": "",
      "tag": "header",
      "color": _vm.primaryColor,
      "application": ""
    }
  }, [_c('vc-toolbar-icon-left', {
    attrs: {
      "icon": "menu"
    },
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }), _vm._v(" "), _c('vc-toolbar-title', [_vm._v("Vue Chords")]), _vm._v(" "), _c('vc-toolbar-controls-right', _vm._l((_vm.toolbarLinks), function(link, index) {
    return (_vm.toolbarLinks.length) ? _c('vc-button', {
      key: index,
      class: ['ml-0'],
      attrs: {
        "icon-button": "",
        "tag": link.external ? 'a' : 'router-link',
        "target": link.external ? '_blank' : '_self',
        "to": link.to,
        "color": _vm.primaryColor,
        "title": link.hint
      }
    }, [_c('vc-icon', [_vm._v(_vm._s(link.icon))])], 1) : _vm._e()
  }))], 1), _vm._v(" "), _c('vc-container', {
    attrs: {
      "tag": "main",
      "application": ""
    }
  }, [_c('vc-layout', {
    attrs: {
      "spacing": 8
    }
  }, [_c('vc-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h1', {
    class: _vm.display1
  }, [_vm._v(_vm._s(_vm.siteTitle))]), _vm._v(" "), _c('p', [_vm._v("VcChordDiagram is an open source guitar chord diagram generator for the "), _c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("VueJs")]), _vm._v(" JavaScript framework,\n            wrapped as an ES6 "), _c('a', {
    attrs: {
      "href": "#getting-started"
    }
  }, [_vm._v("module")]), _vm._v(" and available on "), _c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/vc-chord-diagram",
      "target": "_blank"
    }
  }, [_vm._v("NPM")]), _vm._v(",\n            "), _c('a', {
    attrs: {
      "href": "https://yarnpkg.com/en/package/vc-chord-diagram",
      "target": "_blank"
    }
  }, [_vm._v("Yarn")]), _vm._v(" and on jsDelivr and UnPkg CDN. It is fully customizable and supports different number of\n          strings and tunings.")])]), _vm._v(" "), _c('vc-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', {
    class: _vm.title,
    attrs: {
      "id": "demos"
    }
  }, [_vm._v("Demos")])]), _vm._v(" "), _c('vc-col', {
    class: ['align-center'],
    attrs: {
      "lg12": "",
      "md24": "",
      "span": 12
    }
  }, [_c('vc-layout', [_c('vc-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', {
    class: _vm.subheading
  }, [_vm._v("Rendered as HTML")])]), _vm._v(" "), _vm._l((_vm.samples), function(sample, index) {
    return _c('vc-col', {
      key: index,
      class: ['align-center'],
      attrs: {
        "span": 8,
        "md4": "",
        "sm8": "",
        "xs12": ""
      }
    }, [_c('vc-chord-diagram', {
      attrs: {
        "title": sample.chord,
        "color": sample.color,
        "description": ("Description of the " + (sample.chord) + " chord"),
        "width": _vm.width,
        "height": _vm.height,
        "setup": _vm.chords[sample.chord]
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('vc-col', {
    class: ['align-center'],
    attrs: {
      "lg12": "",
      "md24": "",
      "span": 12
    }
  }, [_c('vc-layout', [_c('vc-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', {
    class: _vm.subheading
  }, [_vm._v("Rendered as Images")])]), _vm._v(" "), _vm._l((_vm.samples), function(sample, index) {
    return _c('vc-col', {
      key: index,
      attrs: {
        "span": 8,
        "md4": "",
        "sm8": "",
        "xs12": ""
      }
    }, [_c('vc-chord-diagram', {
      attrs: {
        "title": sample.chord,
        "color": sample.color,
        "description": ("Description of the " + (sample.chord) + " chord"),
        "width": _vm.width,
        "height": _vm.height,
        "canvas": true,
        "setup": _vm.chords[sample.chord]
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('vc-col', {
    attrs: {
      "md24": "",
      "span": 24,
      "id": "getting-started"
    }
  }, [_c('vc-layout', {
    attrs: {
      "spacing": 8
    }
  }, [_c('vc-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h2', {
    class: _vm.title
  }, [_vm._v("Installation")])]), _vm._v(" "), _c('vc-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h3', {
    class: _vm.subheading
  }, [_vm._v("NPM")]), _vm._v(" "), _c('code', [_vm._v("$ npm install vue-chord-diagram --save")]), _vm._v(" "), _c('h3', {
    class: _vm.subheading
  }, [_vm._v("Yarn")]), _vm._v(" "), _c('code', [_vm._v("$ yarn add vue-chord-diagram")]), _vm._v(" "), _c('h3', {
    class: _vm.subheading
  }, [_vm._v("jsDelivr CDN")]), _vm._v(" "), _c('code', [_c('span', {
    class: ['font-grey']
  }, [_vm._v("<!-- stylesheet -->")]), _c('br'), _vm._v("\n                <link rel=\"stylesheet\" href=\"https://cdn.jsdelivr.net/npm/vuecidity@/dist/lib/vuecidity.min.css\" />"), _c('br'), _vm._v(" "), _c('span', {
    class: ['font-grey']
  }, [_vm._v("<!-- vuejs -->")]), _c('br'), _vm._v("\n                <script src=\"https://cdn.jsdelivr.net/npm/vue@2/dist/vue.min.js\"></script>"), _c('br'), _vm._v(" "), _c('span', {
    class: ['font-grey']
  }, [_vm._v("<!-- vc-chord-diagram -->")]), _c('br'), _vm._v("\n                <script src=\"https://cdn.jsdelivr.net/npm/vc-chord-diagram\"></script>"), _c('br'), _vm._v(" "), _c('span', {
    class: ['font-grey']
  }, [_vm._v("<!-- or -->")]), _c('br'), _vm._v("\n                <script src=\"https://cdn.jsdelivr.net/npm/vc-chord-diagram/dist/lib/vc-chord-diagram.min.js\"></script>"), _c('br')]), _vm._v(" "), _c('h3', {
    class: _vm.subheading
  }, [_vm._v("UnPkg CDN")]), _vm._v(" "), _c('code', [_c('span', {
    class: ['font-grey']
  }, [_vm._v("<!-- stylesheet -->")]), _c('br'), _vm._v("\n                <link rel=\"stylesheet\" href=\"https://unpkg.com/vc-chord-diagram/dist/lib/vc-chord-diagram.min.css\" />"), _c('br'), _vm._v(" "), _c('span', {
    class: ['font-grey']
  }, [_vm._v("<!-- vuejs -->")]), _c('br'), _vm._v("\n                <script src=\"https://unpkg.com/vue/dist/vue.js\"></script>"), _c('br'), _vm._v(" "), _c('span', {
    class: ['font-grey']
  }, [_vm._v("<!-- vc-chord-diagram -->")]), _c('br'), _vm._v("\n                <script src=\"https://unpkg.com/vc-chord-diagram/dist/lib/vc-chord-diagram.min.js\"></script>"), _c('br')])]), _vm._v(" "), _c('vc-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h2', {
    class: _vm.title
  }, [_vm._v("Dependencies")]), _vm._v(" "), _c('p', [_vm._v("VueChordDiagram requires "), _c('a', {
    attrs: {
      "href": "https://vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("VueJs")]), _vm._v("\n                and "), _c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/html-to-image",
      "target": "_blank"
    }
  }, [_vm._v("HtmlToImage")]), _vm._v(",\n                which are included in "), _c('code', [_vm._v("package.json")]), _vm._v(".")])])], 1)], 1), _vm._v(" "), _c('vc-col', {
    attrs: {
      "md24": "",
      "span": 24,
      "id": "docs"
    }
  }, [_c('h2', {
    class: _vm.title
  }, [_vm._v("Documentation")]), _vm._v(" "), _c('p', [_vm._v("After installation, you need to include the "), _c('code', [_vm._v("vc-chord-diagram")]), _vm._v(" module and the stylesheet\n            to your project.")]), _vm._v(" "), _c('code', [_c('span', {
    class: ['font-grey']
  }, [_vm._v("// import the module")]), _c('br'), _vm._v("\n            import VcChordDiagram from 'vc-chord-diagram'"), _c('br'), _vm._v(" "), _c('span', {
    class: ['font-grey']
  }, [_vm._v("// import the stylesheet")]), _c('br'), _vm._v("\n            import '../node_modules/vc-chord-diagram/dist/lib/vc-chord-diagram.min.css'"), _c('br'), _vm._v(" "), _c('span', {
    class: ['font-grey']
  }, [_vm._v("// add to Vue")]), _c('br'), _vm._v("\n            Vue.use(VcChordDiagram)"), _c('br'), _vm._v(" "), _c('span', {
    class: ['font-grey']
  }, [_vm._v("// or add it to another Vue component")]), _c('br'), _vm._v("\n            components: {"), _c('br'), _vm._v("\n              VcChordDiagram"), _c('br'), _vm._v("\n            }\n          ")]), _vm._v(" "), _c('h3', {
    class: _vm.subheading
  }, [_vm._v("Usage")]), _vm._v(" "), _c('p', [_vm._v("To create a single chord diagram, add the "), _c('code', [_vm._v("vc-chord-diagram")]), _vm._v("\n            tag to your page and customize it via the attributes below\n            (only the "), _c('code', [_vm._v("setup")]), _vm._v(" attribute is required).")]), _vm._v(" "), _c('code', [_vm._v("\n            <vc-chord-diagram />\n          ")]), _vm._v(" "), _c('h3', {
    class: _vm.subheading
  }, [_vm._v("Attributes")]), _vm._v(" "), _c('p', [_vm._v("Below are the attributes that can be used to customize the look and feel of the component.")]), _vm._v(" "), _c('ul', {
    class: ['font-grey', 'font-l-600', 'small']
  }, [_c('li', [_c('code', [_vm._v("setup")]), _vm._v(" Required attribute ("), _c('code', [_vm._v("Object")]), _vm._v("), contains the chord setup, fingers, position and tuning.\n              You can add as many strings as you want. Regardless of the "), _c('code', [_vm._v("startAt")]), _vm._v(" position property,\n              you should always count the positions as if they start from the first fret. Example of a "), _c('code', [_vm._v("setup")]), _vm._v(" object:\n              "), _c('pre', [_c('code', [_vm._v("{\n  startAt: 1, "), _c('span', {
    class: ['font-grey']
  }, [_vm._v("// position to start the chord at")]), _vm._v("\n  tuning: ['E', 'A', 'D', 'G', 'B', 'E'], "), _c('span', {
    class: ['font-grey']
  }, [_vm._v("// tuning")]), _vm._v("\n  strings: [{ "), _c('span', {
    class: ['font-grey']
  }, [_vm._v("// strings array, starting from the lowest string")]), _vm._v("\n    fret: 0, "), _c('span', {
    class: ['font-grey']
  }, [_vm._v("// fret (regardless of the startAt, frets should always start from 0)")]), _vm._v("\n    finger: 'x' "), _c('span', {
    class: ['font-grey']
  }, [_vm._v("// finger ('x' means muted, '0' - open string)")]), _vm._v("\n  }, {\n    fret: 0,\n    finger: 0\n  }, {\n    fret: 2,\n    finger: 3\n  }, {\n    fret: 2,\n    finger: 2\n  }, {\n    fret: 1,\n    finger: 1\n  }, {\n    fret: 0,\n    finger: 0\n  }]\n}")])])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("canvas")]), _vm._v(" Optional attribute ("), _c('code', [_vm._v("Boolean")]), _vm._v("), default value is "), _c('code', [_vm._v("false")]), _vm._v(".\n              If set to "), _c('code', [_vm._v("true")]), _vm._v(",\n              the chord diagram will render as an image, otherwise as HTML.\n            ")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("title")]), _vm._v(" Optional attribute ("), _c('code', [_vm._v("String")]), _vm._v("), chord title/name.\n            ")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("description")]), _vm._v(" Optional attribute ("), _c('code', [_vm._v("String")]), _vm._v("), chord description.\n            ")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("fingers")]), _vm._v(" Optional attribute ("), _c('code', [_vm._v("Boolean")]), _vm._v("), toggle the visibility of the fingers bar\n              at the bottom of the diagram\n            ")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("width")]), _vm._v(" Optional attribute ("), _c('code', [_vm._v("String")]), _vm._v("), width of the diagram in pixels of percentage.\n              The default value is "), _c('code', [_vm._v("'160px'")]), _vm._v(".\n            ")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("height")]), _vm._v(" Optional attribute ("), _c('code', [_vm._v("String")]), _vm._v("), height of the diagram in pixels. The default\n              value is "), _c('code', [_vm._v("'100px'")]), _vm._v(".\n            ")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("notes")]), _vm._v(" Optional attribute ("), _c('code', [_vm._v("Boolean")]), _vm._v("), toggle the visibility of the nodes/keys bar\n              at the top of the diagram. The default value is "), _c('code', [_vm._v("true")]), _vm._v(".\n            ")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("position")]), _vm._v(" Optional attribute ("), _c('code', [_vm._v("Boolean")]), _vm._v("), toggle the visibility of the position bar\n              at the left of the diagram. The default value is "), _c('code', [_vm._v("true")]), _vm._v(".\n            ")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("color")]), _vm._v(" Optional attribute ("), _c('code', [_vm._v("String")]), _vm._v("), hex, rgb(a) or named color of the diagram.\n              The default value is "), _c('code', [_vm._v("'#000'")]), _vm._v(".\n            ")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("bg-color")]), _vm._v(" Optional attribute ("), _c('code', [_vm._v("String")]), _vm._v("), hex, rgb(a) or named background color\n              of the diagram. The default value is "), _c('code', [_vm._v("'#fff'")]), _vm._v(".\n            ")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("dot-size")]), _vm._v(" Optional attribute ("), _c('code', [_vm._v("Number")]), _vm._v("), finger dot size in pixels. The default\n              value is "), _c('code', [_vm._v("10")]), _vm._v(" (pixels).\n            ")])])])], 1)], 1), _vm._v(" "), _c('vc-footer', {
    attrs: {
      "narrow": "",
      "color": _vm.primaryColor,
      "align": "right"
    }
  }, [_vm._v("\n      © " + _vm._s(_vm.year) + " Component, documentation and demo site built with "), _c('a', {
    attrs: {
      "href": "https://vuecidity.wemakesites.net/",
      "target": "_blank"
    }
  }, [_vm._v("Vuecidity")]), _vm._v(" for\n      "), _c('a', {
    attrs: {
      "href": "https://vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("VueJs")]), _vm._v(" by "), _c('a', {
    attrs: {
      "href": "https://wemakesites.net/",
      "target": "_blank"
    }
  }, [_vm._v("Martin Ivanov")])]), _vm._v(" "), _c('vc-social-bar', {
    attrs: {
      "size": "small",
      "button-color": _vm.primaryColor,
      "fixed": true,
      "items": _vm.social
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29317692","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 105
// module chunks = 1